import { useState } from 'react';
import Button from 'react-bootstrap/esm/Button';
import Spinner from 'react-bootstrap/esm/Spinner';
import { changeBidStatus, getVehiclesForBids } from '../../../api/Commerce';
import ModalCentered from '../../../components/ModalCentered';

function BiddingsBtnGroup({
  table = false,
  competitionStatus,
  competitionId,
  setShowChangeStatusError,
  vehicle,
  setVehicles,
}) {
  const [updatingBidDraw, setUpdatingBidDraw] = useState(false);
  const [updatingBidOpen, setUpdatingBidOpen] = useState(false);
  const [showRedrawModal, setShowRedrawModal] = useState(false);

  async function fetchVehicles() {
    const fetchedVehicles = await getVehiclesForBids(competitionId);

    if (fetchedVehicles) {
      setVehicles(fetchedVehicles);
      setUpdatingBidDraw(false);
      setUpdatingBidOpen(false);
    }
  }

  const onDrawWinner = async () => {
    setUpdatingBidDraw(true);

    const result = await changeBidStatus(
      competitionId,
      vehicle.vehicleId,
      'lotterydrawn'
    );

    if (result) {
      switch (result.statusCode) {
        case 200:
          fetchVehicles();
          break;
        default:
          setShowChangeStatusError(true);
          setUpdatingBidDraw(false);
          break;
      }
    }
  };

  const onDrawNewWinner = async () => {
    setUpdatingBidDraw(true);

    const result = await changeBidStatus(
      competitionId,
      vehicle.vehicleId,
      'lotteryredrawn'
    );

    if (result) {
      switch (result.statusCode) {
        case 200:
          fetchVehicles();
          break;
        default:
          setShowChangeStatusError(true);
          setUpdatingBidDraw(false);
          break;
      }
    }

    setShowRedrawModal(false);
  };

  const onOpenForBids = async () => {
    setUpdatingBidOpen(true);

    const result = await changeBidStatus(
      competitionId,
      vehicle.vehicleId,
      'openforbids'
    );

    if (result) {
      switch (result.statusCode) {
        case 200:
          fetchVehicles();
          break;
        default:
          setShowChangeStatusError(true);
          setUpdatingBidOpen(false);
          break;
      }
    }
  };

  const onCloseForBids = async () => {
    setUpdatingBidOpen(true);

    const result = await changeBidStatus(
      competitionId,
      vehicle.vehicleId,
      'closedforbids'
    );

    if (result) {
      switch (result.statusCode) {
        case 200:
          fetchVehicles();
          break;
        default:
          setShowChangeStatusError(true);
          setUpdatingBidOpen(false);
          break;
      }
    }
  };

  return (
    <>
      {competitionStatus === 'Pågående' ? (
        <div
          className={`d-flex gap-2 gap-xl-3 ${
            table ? 'justify-content-end' : 'justify-content-between'
          }`}
        >
          {vehicle?.numberOfBids > 0 &&
          (vehicle?.bidStatus === 'notopen' ||
            vehicle?.bidStatus === 'closedforbids') ? (
            <Button
              variant='outline-primary'
              className='d-flex align-items-center justify-conent-between gap-1 gap-xl-2'
              onClick={() => onDrawWinner()}
            >
              {updatingBidDraw ? (
                <>
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                    className='me-2'
                  />
                  <span className='visually-hidden'>Loading...</span>
                </>
              ) : (
                <>
                  <span className='material-symbols-outlined'>shuffle</span>
                </>
              )}
              Lotta vinnare
            </Button>
          ) : vehicle?.bidStatus === 'lotterydrawn' ||
            vehicle?.bidStatus === 'lotteryredrawn' ? (
            <Button
              variant='outline-primary'
              className='d-flex align-items-center justify-conent-between gap-1 gap-xl-2'
              onClick={() => setShowRedrawModal(true)}
            >
              {updatingBidDraw ? (
                <>
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                    className='me-2'
                  />
                  <span className='visually-hidden'>Loading...</span>
                </>
              ) : (
                <>
                  <span className='material-symbols-outlined'>shuffle</span>
                </>
              )}
              Lotta ny vinnare
            </Button>
          ) : (
            <Button
              variant='outline-primary'
              className='d-flex align-items-center justify-conent-between gap-1 gap-xl-2'
              disabled
            >
              <span className='material-symbols-outlined'>shuffle</span>
              Lotta vinnare
            </Button>
          )}

          {vehicle?.bidStatus === 'lotterydrawn' ||
          vehicle?.bidStatus === 'lotteryredrawn' ? (
            <Button
              variant='outline-primary'
              className='d-flex align-items-center justify-content-between gap-1 gap-xl-2'
              disabled
            >
              <span className='material-symbols-outlined'>lock_open</span>
              Öppna för anbud
            </Button>
          ) : vehicle?.bidStatus === 'notopen' ||
            vehicle?.bidStatus === 'closedforbids' ? (
            <Button
              variant='outline-primary'
              className='d-flex align-items-center justify-content-between gap-1 gap-xl-2'
              onClick={() => onOpenForBids()}
            >
              {updatingBidOpen ? (
                <>
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                    className='me-2'
                  />
                  <span className='visually-hidden'>Loading...</span>
                </>
              ) : (
                <>
                  <span className='material-symbols-outlined'>lock_open</span>
                </>
              )}
              Öppna för anbud
            </Button>
          ) : (
            <Button
              variant='outline-primary'
              className='d-flex align-items-center justify-content-between gap-2'
              onClick={() => onCloseForBids()}
            >
              {updatingBidOpen ? (
                <>
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                    className='me-2'
                  />
                  <span className='visually-hidden'>Loading...</span>
                </>
              ) : (
                <>
                  <span className='material-symbols-outlined'>lock</span>
                </>
              )}
              Stäng för anbud
            </Button>
          )}
        </div>
      ) : (
        <div className='d-flex gap-2 gap-xl-3 justify-content-end'>
          <Button
            variant='outline-primary'
            className='d-flex align-items-center justify-conent-between gap-1 gap-xl-2'
            disabled
          >
            <span className='material-symbols-outlined'>shuffle</span>
            Lotta vinnare
          </Button>
          <Button
            variant='outline-primary'
            className='d-flex align-items-center justify-content-between gap-1 gap-xl-2'
            disabled
          >
            <span className='material-symbols-outlined'>lock_open</span>
            Öppna för anbud
          </Button>
        </div>
      )}
      <ModalCentered
        show={showRedrawModal}
        header='Bekräfta omlottning'
        body='Är du säker på att du vill lotta en ny vinnare till fordonet?'
        onConfirm={() => onDrawNewWinner()}
        onHide={() => setShowRedrawModal(false)}
        loadingConfirm={updatingBidDraw}
        confirmBtnText='Fortsätt'
      />
    </>
  );
}

export default BiddingsBtnGroup;
